import { useFeatureIdentify } from 'map-feature-info'
import { useDispatch } from 'react-redux'

import {
  closeMapFeatureInfoDrawer,
  openMapFeatureInfoDrawer
} from '~map-preview/states/ui'

import { PointSelectorPlugin } from '~map-preview/App/Map/Plugins/PointSelectorPlugin'

interface FeatureIdentifyPluginProps {
  layer: string
}

function FeatureIdentifyPlugin(props: FeatureIdentifyPluginProps) {
  const { layer } = props

  const dispatch = useDispatch()

  const { identify } = useFeatureIdentify()

  const handlePointSelect = (feature) => {
    identify(feature)
    dispatch(openMapFeatureInfoDrawer())
  }

  const handlePointDeselect = () => {
    dispatch(closeMapFeatureInfoDrawer())
  }

  return (
    <PointSelectorPlugin
      layer={layer}
      onPointSelect={handlePointSelect}
      onPointDeselect={handlePointDeselect}
    />
  )
}

export { FeatureIdentifyPlugin }
